export interface OidcConfig {
    authority: string;
    clientId: string;
    redirectUri: string;
    postLogoutRedirectUri: string;
    silentRedirectUri?: string;
    scope?: string;
    responseType?: string;
    automaticSilentRenew?: boolean;
}

declare global {
    interface Window {
        __COLLECTIVE_MARKET_OIDC__?: Partial<OidcConfig>;
    }
}

window.__COLLECTIVE_MARKET_OIDC__ = {
    authority: IdentityAuthority,
    clientId: IdentityClientID,
    redirectUri: "/auth/callback",
};

const DEFAULT_SCOPE = "openid profile default identity";
const DEFAULT_RESPONSE_TYPE = "code";
const CALLBACK_PATH = "/auth/callback";
const SILENT_RENEW_PATH = "/auth/silent-renew";

const normalizeUrl = (url: string | undefined, fallback: string) => {
    if (!url || url.length === 0) {
        return fallback;
    }

    const hasProtocol = /^https?:\/\//i.test(url);
    if (hasProtocol) {
        return url;
    }

    const base = window.location.origin.replace(/\/$/, "");
    const normalizedPath = url.startsWith("/") ? url : `/${url}`;
    return `${base}${normalizedPath}`;
};

export const getOidcConfig = (): OidcConfig => {
    const globalConfig = window.__COLLECTIVE_MARKET_OIDC__ ?? {};
    const origin = window.location.origin.replace(/\/$/, "");

    const redirectUri = normalizeUrl(globalConfig.redirectUri, `${origin}${CALLBACK_PATH}`);
    const silentRedirectUri = normalizeUrl(globalConfig.silentRedirectUri, `${origin}${SILENT_RENEW_PATH}`);

    const config: OidcConfig = {
        authority: globalConfig.authority ?? "",
        clientId: globalConfig.clientId ?? "",
        redirectUri,
        postLogoutRedirectUri: normalizeUrl(globalConfig.postLogoutRedirectUri, origin),
        silentRedirectUri,
        scope: globalConfig.scope ?? DEFAULT_SCOPE,
        responseType: globalConfig.responseType ?? DEFAULT_RESPONSE_TYPE,
        automaticSilentRenew: globalConfig.automaticSilentRenew ?? true,
    };

    if (!config.authority || !config.clientId) {
        console.warn("OIDC configuration is incomplete. Please provide both authority and clientId via window.__COLLECTIVE_MARKET_OIDC__.");
    }

    return config;
};
